import { OrderStatus } from '@dss-libs/shared/type/common-types';

const ORDER_STATUS_ICON_MAP = new Map<OrderStatus, string>([
  [OrderStatus.Completed, 'check-circle-outline'],
  [OrderStatus.Pending, 'info-circle-outline'],
  [OrderStatus.InProgress, 'info-circle-outline'],
  [OrderStatus.Cancelled, 'close-circle-outline'],
  [OrderStatus.Declined, 'close-circle-outline'],
  [OrderStatus.Expired, 'close-circle-outline'],
]);

export const getOrderStatusIcon = (orderStatus: OrderStatus = OrderStatus.InProgress): string =>
  ORDER_STATUS_ICON_MAP.get(orderStatus) ?? 'info-circle-outline';
